import { Star } from "lucide-react";

export const Rating = ({ rating = 0, size = 18 }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.5;

  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      // Full Star
      stars.push(
        <Star
          key={i}
          size={size}
          className="text-yellow-400 fill-yellow-400"
        />,
      );
    } else if (i === fullStars && hasHalfStar) {
      // Half Star (clip trick)
      stars.push(
        <div key={i} className="relative">
          <Star size={size} className="text-gray-300" />
          <div className="absolute inset-0 overflow-hidden w-1/2">
            <Star size={size} className="text-yellow-400 fill-yellow-400" />
          </div>
        </div>,
      );
    } else {
      // Empty Star
      stars.push(<Star key={i} size={size} className="text-gray-300" />);
    }
  }

  return <div className="flex items-center justify-center gap-1">{stars}</div>;
};
